export default __webpack_public_path__ + "static/media/tick-circle.e648169f.svg";